import DefaultCard from '../../nftFormats/Default/Card/DefaultCard'
import YetiSummerCollectionDetail from '../../nftFormats/YetiSummerCollection/Detail/YetiSummerCollectionDetail'
import ActivityDetail from '../../nftFormats/Default/Activity/ActivityDetail'
import INFTCollections from '../../models/INFTCollections'
import GeneralCard from '../../nftFormats/Generals/Card/GeneralCard'
import GeneralDetail from '../../nftFormats/Generals/Detail/GeneralDetail'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import YetiSummerCollectionLogo from '../../../../assets/nft-logo/YetiSummerCollection.png'
import YetiSpecialCollectionLogo from '../../../../assets/nft-logo/YetiSpecialCollection.png'

export const YetiSwapData: INFTCollections[] = [
  {
    id: 'YetiSummerCollection',
    tokenAddress: '0x1464a510ea8fd3b0db84f5645e4738df4a487442',
    name: 'YetiSwap Summer Collection',
    cardFormat: DefaultCard,
    detailFormat: YetiSummerCollectionDetail,
    activityFormat: ActivityDetail,
    category: 1,
    logo: YetiSummerCollectionLogo,
    creatorAddress: '0x90A42628289896041c2Ba358463259b4b7Ea242C',
    website: 'https://exchange.yetiswap.app/#/nft-marketplace',
    twitter: 'YetiSwap',
    telegram: 'https://t.me/YetiSwap'
  },
  {
    id: 'YetiSpecialCollection',
    tokenAddress: '0xccf2eee3b334bB06E0F91157eC56E8efd6F10dcA',
    name: 'YetiSwap Special Collection',
    cardFormat: GeneralCard,
    detailFormat: GeneralDetail,
    activityFormat: GeneralActivityDetail,
    category: 1,
    logo: YetiSpecialCollectionLogo,
    creatorAddress: '0x90A42628289896041c2Ba358463259b4b7Ea242C',
    website: 'https://exchange.yetiswap.app/#/nft-marketplace',
    twitter: 'YetiSwap',
    telegram: 'https://t.me/YetiSwap'
  }
]

export const YetiSwapCategoryData = {
  [YetiSwapData[0].tokenAddress.toLowerCase()]: YetiSwapData[0].category
}
